(function () {
    angular.module('components.modalSlider', [
        'components.pagination',
        'ui.router'
    ])
        .factory('modalSliderService', modalSliderService)
        .controller('modalSliderController', modalSliderController)
        .directive('modalContainer', modalContainer)
        .directive('modalSlider', modalSlider);

    modalSliderService.$inject = ['$rootScope'];
    function modalSliderService($rootScope) {
        return {
            open: function () {
                $rootScope.$broadcast('toggleModalSlider', true);
            },
            close: function () {
                $rootScope.$broadcast('toggleModalSlider', false);
            }
        }
    }

    modalSliderController.$inject = ['$scope', '$location', '$stateParams'];
    function modalSliderController($scope, $location, $stateParams) {
        var controller = this;
    }

    modalContainer.$inject = ['$stateParams'];
    function modalContainer($stateParams) {
        var directive = {
            replace: true,
            restrict: 'E',
            transclude: true,
            templateUrl: '/angular/components/modalSlider/modalContainer.html',
            link: link,
            controller: 'modalSliderController'
        };
        return directive;
        function link(scope, element, attrs, controller) {
        }
    }

    modalSlider.$inject = ['$rootScope', '$timeout', '$location', '$state', '$stateParams', '$transitions', '$window'];
    function modalSlider($rootScope, $timeout, $location, $state, $stateParams, $transitions, $window) {
        var directive = {
            restrict: 'E',
            replace: true,
            link: link,
            templateUrl: '/angular/components/modalSlider/modalSlider.html',
            require: ['^modalContainer', '^pagination']
        };
        return directive;
        function link(scope, element, attrs, controllers, transclude) {
            var controller = controllers[0];
            var paginator = controllers[1];
            var body = angular.element('body');
            var html = angular.element('html');
            scope.thumbnails = [];
            scope.updateNav = function (index) {
                $state.go('modalSet.item', { item: scope.$ctrl.items[index].urlName })
            };

            var carousel;
            scope.accessCarousel = function (ctrl) {
                carousel = ctrl;
                if ($state.current.name == attrs.state) {
                    startOpen()
                    modalOpen = true;
                }
            }

            var isMedium = $window.matchMedia('only screen and (min-width: 40em)');
            isMedium.addListener(function (mq) {
                scope.$evalAsync(function () {
                    scope.isMedium = mq.matches;
                })
            });
            scope.isMedium = isMedium.matches;

            var win = $(window).on('resize.portfolio', function () {
                $timeout(function () {
                    scope.width = element.width();
                });
            });

            var modalOpen;

            $transitions.onEnter({
                to: attrs.state,
                from: function (state) {
                    return state.name != attrs.state;
                }
            }, function (transition) {
                if (!modalOpen) {
                    startOpen(transition.params('to').item);
                    modalOpen = true;
                }
            });
            $transitions.onExit({
                to: function(state) {
                    return state.name != attrs.state;
                },
                from: attrs.state
            }, function () {
                modalOpen = false;
                startClose();
            });

            $timeout(function () {
                modalBackground = element.find('.background');
                container = element.find('.container');
            });
            var modal;
            var modalBackground, container;
            var win = $(window).on('keydown.portfolio', function (event) {
                if (event.which === 27) {
                    $state.go(attrs.landing);
                }
            });
            var tl;
            var animationSpeed = .6;
            var scrollPos = 0;
            function startOpen(urlName) {
                var urlName = urlName || $stateParams.item;
                var index = 0;
                for (var i = 0; i < carousel.slides.length; i++) {
                    if (carousel.slides[i].urlName === urlName) {
                        index = i;
                        break;
                    }
                }
                $timeout(function () {
                    carousel.goToSlide(index, false);
                });
                if (tl === undefined) {
                    tl = new TimelineMax();
                    tl.add(TweenLite.fromTo(element, .001, {
                        visibility: 'hidden'
                    }, {
                        visibility: 'visible'
                    }));
                    tl.add(TweenLite.fromTo(container, animationSpeed, {
                        opacity: 0
                    }, {
                        opacity: 1
                    }));
                    tl.add(TweenLite.fromTo(modalBackground, animationSpeed, { opacity: 0 }, { opacity: 1, delay: -animationSpeed }));
                }
                else
                    tl.play();
                
                //tl.add(TweenLite.from(image, 1, {
                //    y: boundingBox.top - imgBoundingBox.top - ((imgBoundingBox.height - boundingBox.height) / 2),
                //    x: boundingBox.left - imgBoundingBox.left - ((imgBoundingBox.width - boundingBox.width) / 2),
                //    width: boundingBox.width,
                //    height: boundingBox.height,
                //    delay: -1
                //})).add(TweenLite.from(image, .7, {
                //    rotationY: 180,
                //    delay: -1
                //})).add(TweenLite.to(image, .01, {
                //    clearProps: 'all'
                //}));
                controller.openTrigger = undefined;
                scrollPos = body.scrollTop() || html.scrollTop();
                body.css('top', -scrollPos).addClass('no-scroll');
            }

            function startClose() {
                tl.reverse();
                controller.index = undefined;
                controller.prevIndex = undefined;
                body.css('top', '').removeClass('no-scroll');
                body.scrollTop(scrollPos);
                html.scrollTop(scrollPos);
            }
            scope.$on('$destroy', function () {
                win.off('keydown.portfolio');
            });
        }
    }
})();